import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <>

      <section className="relative bg-industrial-navy text-white py-20 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img src="https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=1600" alt="About Background" className="w-full h-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative mx-auto px-4 sm:px-6 lg:px-8 text-center z-10" style={{ maxWidth: '90%' }}>
          <nav className="text-sm text-gray-300 mb-6" data-aos="fade-up">
            <Link to="/" className="hover:text-white transition">Home</Link> / <span className="text-white">About Us</span>
          </nav>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6" data-aos="fade-up" data-aos-delay="200">About Us</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="400">
            Engineering excellence in industrial automation and control systems for over two decades
          </p>
        </div>
      </section>

      <section className="py-16 bg-white abstract-bg">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 relative z-10" style={{ maxWidth: '90%' }}>
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div data-aos="fade-right">
              <div className="relative">
                <div className="overflow-hidden rounded-lg shadow-2xl">
                  <img src="https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800" alt="Company Overview" className="w-full h-96 object-cover transition-transform duration-500 hover:scale-110" />
                </div>
                <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-6 rounded-lg shadow-xl floating">
                  <div className="text-4xl font-bold">20+</div>
                  <div className="text-sm">Years Experience</div>
                </div>
              </div>
            </div>
            <div data-aos="fade-left">
              <div className="text-sm text-blue-600 font-semibold mb-2">WHO WE ARE</div>
              <h2 className="text-3xl sm:text-4xl font-bold text-industrial-navy mb-6">Leading the Future of Industrial Automation</h2>
              <p className="text-gray-700 mb-4">
                Founded in 2003, we have established ourselves as a trusted partner for critical infrastructure automation across power, water, oil & gas, and renewable energy sectors. Our commitment to engineering excellence and customer success has driven us to deliver innovative solutions that power the world's most demanding industrial applications.
              </p>
              <p className="text-gray-700 mb-6">
                With a team of experienced engineers, certified integration specialists, and dedicated support professionals, we provide end-to-end automation solutions from initial design through implementation, commissioning, and ongoing support. Our solutions are deployed in over 40 countries, monitoring and controlling critical infrastructure that millions depend on every day.
              </p>
              <div className="grid sm:grid-cols-2 gap-4">
                <div className="flex items-start">
                  <i className="fas fa-check-circle text-green-600 text-xl mr-3 mt-1"></i>
                  <div>
                    <h4 className="font-bold mb-1">Mission-Critical Reliability</h4>
                    <p className="text-sm text-gray-600">99.98% system uptime across deployments</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="fas fa-check-circle text-green-600 text-xl mr-3 mt-1"></i>
                  <div>
                    <h4 className="font-bold mb-1">Global Presence</h4>
                    <p className="text-sm text-gray-600">Operating in 40+ countries worldwide</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="fas fa-check-circle text-green-600 text-xl mr-3 mt-1"></i>
                  <div>
                    <h4 className="font-bold mb-1">Expert Team</h4>
                    <p className="text-sm text-gray-600">150+ certified engineers and specialists</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="fas fa-check-circle text-green-600 text-xl mr-3 mt-1"></i>
                  <div>
                    <h4 className="font-bold mb-1">24/7 Support</h4>
                    <p className="text-sm text-gray-600">Round-the-clock technical assistance</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50 grid-bg">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 relative z-10" style={{ maxWidth: '90%' }}>
          <div className="text-center mb-12" data-aos="fade-up">
            <div className="text-sm text-blue-600 font-semibold mb-2">OUR MISSION & VISION</div>
            <h2 className="text-3xl sm:text-4xl font-bold text-industrial-navy mb-4">Driving Innovation in Industrial Automation</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-lg hover-lift card-shine" data-aos="fade-right">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6 floating">
                <i className="fas fa-bullseye text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Our Mission</h3>
              <p className="text-gray-700 mb-4">To deliver reliable, innovative automation solutions that empower critical industries to operate safely, efficiently, and sustainably. We are committed to engineering excellence, customer success, and advancing the future of industrial automation through continuous innovation and unwavering dedication to quality.</p>
              <p className="text-gray-700">We believe that robust automation infrastructure is the foundation of modern industrial operations, and we strive to provide solutions that exceed expectations in performance, reliability, and value.</p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-lg hover-lift card-shine" data-aos="fade-left">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6 floating" style={{ animationDelay: '0.5s' }}>
                <i className="fas fa-eye text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Our Vision</h3>
              <p className="text-gray-700 mb-4">To be the global leader in industrial automation and control systems, recognized for our technical expertise, innovative solutions, and exceptional customer service. We envision a future where intelligent automation enables industries to achieve unprecedented levels of efficiency, safety, and sustainability.</p>
              <p className="text-gray-700">Through strategic partnerships, continuous research and development, and a customer-centric approach, we aim to shape the future of industrial automation and set new standards for excellence in our industry.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white abstract-bg">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 relative z-10" style={{ maxWidth: '90%' }}>
          <div className="text-center mb-12" data-aos="fade-up">
            <div className="text-sm text-blue-600 font-semibold mb-2">CORE VALUES</div>
            <h2 className="text-3xl sm:text-4xl font-bold text-industrial-navy mb-4">What Drives Us</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">Our values guide every decision we make and every solution we deliver</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center" data-aos="zoom-in" data-aos-delay="0">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-600 to-blue-800 rounded-full flex items-center justify-center mx-auto mb-4 floating shadow-lg">
                <i className="fas fa-shield-alt text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">Reliability</h3>
              <p className="text-gray-600">Building systems that perform flawlessly in the most demanding environments, ensuring mission-critical operations never fail.</p>
            </div>
            <div className="text-center" data-aos="zoom-in" data-aos-delay="100">
              <div className="w-20 h-20 bg-gradient-to-br from-indigo-600 to-indigo-800 rounded-full flex items-center justify-center mx-auto mb-4 floating shadow-lg" style={{ animationDelay: '0.5s' }}>
                <i className="fas fa-lightbulb text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">Innovation</h3>
              <p className="text-gray-600">Continuously advancing our technology and methodologies to deliver cutting-edge solutions that drive industry forward.</p>
            </div>
            <div className="text-center" data-aos="zoom-in" data-aos-delay="200">
              <div className="w-20 h-20 bg-gradient-to-br from-purple-600 to-purple-800 rounded-full flex items-center justify-center mx-auto mb-4 floating shadow-lg" style={{ animationDelay: '1s' }}>
                <i className="fas fa-users text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">Partnership</h3>
              <p className="text-gray-600">Working closely with clients as trusted advisors, understanding their challenges and delivering tailored solutions.</p>
            </div>
            <div className="text-center" data-aos="zoom-in" data-aos-delay="300">
              <div className="w-20 h-20 bg-gradient-to-br from-cyan-600 to-cyan-800 rounded-full flex items-center justify-center mx-auto mb-4 floating shadow-lg" style={{ animationDelay: '1.5s' }}>
                <i className="fas fa-award text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">Excellence</h3>
              <p className="text-gray-600">Maintaining the highest standards in engineering, quality, and service across every aspect of our business.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-industrial-navy text-white decorative-bg circuit-bg">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 relative z-10" style={{ maxWidth: '90%' }}>
          <div className="text-center mb-12" data-aos="fade-up">
            <div className="text-sm text-blue-300 font-semibold mb-2">BY THE NUMBERS</div>
            <h2 className="text-3xl sm:text-4xl font-bold mb-4">Our Impact</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">Delivering measurable results across critical infrastructure worldwide</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center" data-aos="fade-up" data-aos-delay="0">
              <div className="text-5xl font-bold mb-2">500+</div>
              <p className="text-gray-300 text-lg">Projects Completed</p>
              <p className="text-sm text-gray-400 mt-2">Across 40+ countries</p>
            </div>
            <div className="text-center" data-aos="fade-up" data-aos-delay="100">
              <div className="text-5xl font-bold mb-2">99.98%</div>
              <p className="text-gray-300 text-lg">System Uptime</p>
              <p className="text-sm text-gray-400 mt-2">Industry-leading reliability</p>
            </div>
            <div className="text-center" data-aos="fade-up" data-aos-delay="200">
              <div className="text-5xl font-bold mb-2">150+</div>
              <p className="text-gray-300 text-lg">Expert Engineers</p>
              <p className="text-sm text-gray-400 mt-2">Certified specialists</p>
            </div>
            <div className="text-center" data-aos="fade-up" data-aos-delay="300">
              <div className="text-5xl font-bold mb-2">24/7</div>
              <p className="text-gray-300 text-lg">Technical Support</p>
              <p className="text-sm text-gray-400 mt-2">Always available</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50 grid-bg">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 relative z-10" style={{ maxWidth: '90%' }}>
          <div className="text-center mb-12" data-aos="fade-up">
            <div className="text-sm text-blue-600 font-semibold mb-2">EXPERTISE</div>
            <h2 className="text-3xl sm:text-4xl font-bold text-industrial-navy mb-4">Our Key Strengths</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">Comprehensive capabilities that set us apart in the industry</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { icon: 'cogs', title: 'Engineering Capability', desc: 'In-house R&D team with deep expertise in automation, control systems, and industrial networking.', items: ['Custom solution design', 'System integration', 'Performance optimization'] },
              { icon: 'project-diagram', title: 'Integration', desc: 'Successfully deployed 500+ projects across power, water, oil & gas, and industrial sectors.', items: ['Turnkey solutions', 'Legacy system upgrades', 'Commissioning support'] },
              { icon: 'headset', title: 'Support', desc: 'Global support network with local presence and rapid response capabilities.', items: ['Emergency response', 'Remote diagnostics', 'Preventive maintenance'] }
            ].map((item, index) => (
              <div key={index} className="bg-white p-8 rounded-lg shadow-lg hover-lift card-shine" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6 floating" style={{ animationDelay: `${index * 0.5}s` }}>
                  <i className={`fas fa-${item.icon} text-3xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                <p className="text-gray-600 mb-4">{item.desc}</p>
                <ul className="text-sm text-gray-600 space-y-2">
                  {item.items.map((listItem, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="fas fa-check text-green-600 mr-2 mt-1"></i>
                      {listItem}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white abstract-bg">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 relative z-10" style={{ maxWidth: '90%' }}>
          <div className="text-center mb-12" data-aos="fade-up">
            <div className="text-sm text-blue-600 font-semibold mb-2">TRUSTED PARTNERSHIPS</div>
            <h2 className="text-3xl sm:text-4xl font-bold text-industrial-navy mb-4">Our Clients & Vendor Certificates</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">Proud to partner with industry-leading brands and certified by top technology vendors</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: 'handshake', title: 'Honeywell', desc: 'Authorized System Integrator' },
              { icon: 'handshake', title: 'Siemens', desc: 'Solution Partner' },
              { icon: 'handshake', title: 'Schneider Electric', desc: 'Certified Partner' },
              { icon: 'handshake', title: 'ABB', desc: 'Authorized Distributor' }
            ].map((vendor, index) => (
              <div key={index} className="bg-gray-50 p-6 rounded-lg text-center hover-lift" data-aos="zoom-in" data-aos-delay={index * 100}>
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <i className={`fas fa-${vendor.icon} text-3xl text-blue-600`}></i>
                </div>
                <h3 className="font-bold mb-2">{vendor.title}</h3>
                <p className="text-sm text-gray-600">{vendor.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-industrial-navy text-white decorative-bg circuit-bg">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 relative z-10" style={{ maxWidth: '90%' }}>
          <div className="text-center mb-12" data-aos="fade-up">
            <h2 className="text-3xl sm:text-4xl font-bold mb-4">Ready to Partner With Us?</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8">Let's discuss how our expertise can help you achieve your automation goals. Our team is ready to provide consultation, technical support, and custom solutions tailored to your specific requirements.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/#contact" className="bg-white text-db-dark hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold transition inline-flex items-center justify-center transform hover:scale-105">
                <i className="fas fa-envelope mr-2"></i>Contact Our Team
              </Link>
              <Link to="/#featured-products" className="bg-db-red hover:bg-red-700 px-8 py-4 rounded-lg font-semibold transition inline-flex items-center justify-center transform hover:scale-105">
                <i className="fas fa-box-open mr-2"></i>Explore Solutions
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
